// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(59, 130, 246, 0.5);
  --tw-ring-offset-shadow: 0 0 rgba(0,0,0,0);
  --tw-ring-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow-colored: 0 0 rgba(0,0,0,0);
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(59, 130, 246, 0.5);
  --tw-ring-offset-shadow: 0 0 rgba(0,0,0,0);
  --tw-ring-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow-colored: 0 0 rgba(0,0,0,0);
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.my-conversations .tw-pointer-events-none {
  pointer-events: none;
}
.my-conversations .tw-fixed {
  position: fixed;
}
.my-conversations .tw-absolute {
  position: absolute;
}
.my-conversations .tw-relative {
  position: relative;
}
.my-conversations .tw-inset-0 {
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
}
.my-conversations .tw-bottom-0 {
  bottom: 0px;
}
.my-conversations .tw-bottom-2 {
  bottom: 8px;
}
.my-conversations .tw-bottom-full {
  bottom: 100%;
}
.my-conversations .tw-left-0 {
  left: 0px;
}
.my-conversations .tw-left-1\\/2 {
  left: 50%;
}
.my-conversations .tw-left-3 {
  left: 12px;
}
.my-conversations .tw-left-4 {
  left: 16px;
}
.my-conversations .tw-left-full {
  left: 100%;
}
.my-conversations .tw-right-0 {
  right: 0px;
}
.my-conversations .tw-right-2 {
  right: 8px;
}
.my-conversations .tw-right-3 {
  right: 12px;
}
.my-conversations .tw-right-4 {
  right: 16px;
}
.my-conversations .tw-right-8 {
  right: 32px;
}
.my-conversations .tw-right-full {
  right: 100%;
}
.my-conversations .tw-top-1\\/2 {
  top: 50%;
}
.my-conversations .tw-top-2 {
  top: 8px;
}
.my-conversations .tw-z-10 {
  z-index: 10;
}
.my-conversations .tw-z-20 {
  z-index: 20;
}
.my-conversations .tw-z-40 {
  z-index: 40;
}
.my-conversations .tw-z-50 {
  z-index: 50;
}
.my-conversations .tw-z-\\[1200\\] {
  z-index: 1200;
}
.my-conversations .tw-z-\\[99999\\] {
  z-index: 99999;
}
.my-conversations .tw-z-\\[9999\\] {
  z-index: 9999;
}
.my-conversations .tw-col-span-2 {
  grid-column: span 2 / span 2;
}
.my-conversations .tw-col-span-3 {
  grid-column: span 3 / span 3;
}
.my-conversations .tw-col-span-5 {
  grid-column: span 5 / span 5;
}
.my-conversations .tw-col-span-7 {
  grid-column: span 7 / span 7;
}
.my-conversations .tw-m-0 {
  margin: 0px;
}
.my-conversations .tw-mx-1 {
  margin-left: 4px;
  margin-right: 4px;
}
.my-conversations .tw-mx-4 {
  margin-left: 16px;
  margin-right: 16px;
}
.my-conversations .tw-mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-conversations .tw-my-3 {
  margin-top: 12px;
  margin-bottom: 12px;
}
.my-conversations .tw-my-4 {
  margin-top: 16px;
  margin-bottom: 16px;
}
.my-conversations .-tw-ml-1 {
  margin-left: -4px;
}
.my-conversations .tw-mb-1 {
  margin-bottom: 4px;
}
.my-conversations .tw-mb-1\\.5 {
  margin-bottom: 6px;
}
.my-conversations .tw-mb-2 {
  margin-bottom: 8px;
}
.my-conversations .tw-mb-3 {
  margin-bottom: 12px;
}
.my-conversations .tw-mb-4 {
  margin-bottom: 16px;
}
.my-conversations .tw-mb-6 {
  margin-bottom: 24px;
}
.my-conversations .tw-ml-2 {
  margin-left: 8px;
}
.my-conversations .tw-ml-4 {
  margin-left: 16px;
}
.my-conversations .tw-ml-auto {
  margin-left: auto;
}
.my-conversations .tw-mr-1 {
  margin-right: 4px;
}
.my-conversations .tw-mr-2 {
  margin-right: 8px;
}
.my-conversations .tw-mr-3 {
  margin-right: 12px;
}
.my-conversations .tw-mt-1 {
  margin-top: 4px;
}
.my-conversations .tw-mt-2 {
  margin-top: 8px;
}
.my-conversations .tw-mt-3 {
  margin-top: 12px;
}
.my-conversations .tw-mt-4 {
  margin-top: 16px;
}
.my-conversations .tw-mt-6 {
  margin-top: 24px;
}
.my-conversations .tw-block {
  display: block;
}
.my-conversations .tw-inline-block {
  display: inline-block;
}
.my-conversations .tw-flex {
  display: flex;
}
.my-conversations .tw-inline-flex {
  display: inline-flex;
}
.my-conversations .tw-grid {
  display: grid;
}
.my-conversations .tw-hidden {
  display: none;
}
.my-conversations .tw-h-1 {
  height: 4px;
}
.my-conversations .tw-h-1\\.5 {
  height: 6px;
}
.my-conversations .tw-h-10 {
  height: 40px;
}
.my-conversations .tw-h-11 {
  height: 44px;
}
.my-conversations .tw-h-12 {
  height: 48px;
}
.my-conversations .tw-h-16 {
  height: 64px;
}
.my-conversations .tw-h-2 {
  height: 8px;
}
.my-conversations .tw-h-2\\.5 {
  height: 10px;
}
.my-conversations .tw-h-20 {
  height: 80px;
}
.my-conversations .tw-h-3 {
  height: 12px;
}
.my-conversations .tw-h-4 {
  height: 16px;
}
.my-conversations .tw-h-48 {
  height: 192px;
}
.my-conversations .tw-h-5 {
  height: 20px;
}
.my-conversations .tw-h-6 {
  height: 24px;
}
.my-conversations .tw-h-8 {
  height: 32px;
}
.my-conversations .tw-h-\\[185px\\] {
  height: 185px;
}
.my-conversations .tw-h-auto {
  height: auto;
}
.my-conversations .tw-h-full {
  height: 100%;
}
.my-conversations .tw-max-h-60 {
  max-height: 240px;
}
.my-conversations .tw-max-h-96 {
  max-height: 384px;
}
.my-conversations .tw-max-h-\\[180px\\] {
  max-height: 180px;
}
.my-conversations .tw-max-h-\\[185px\\] {
  max-height: 185px;
}
.my-conversations .tw-max-h-\\[240px\\] {
  max-height: 240px;
}
.my-conversations .tw-max-h-\\[300px\\] {
  max-height: 300px;
}
.my-conversations .tw-max-h-\\[400px\\] {
  max-height: 400px;
}
.my-conversations .tw-max-h-full {
  max-height: 100%;
}
.my-conversations .tw-min-h-24 {
  min-height: 96px;
}
.my-conversations .tw-min-h-\\[185px\\] {
  min-height: 185px;
}
.my-conversations .tw-min-h-\\[200px\\] {
  min-height: 200px;
}
.my-conversations .tw-min-h-\\[600px\\] {
  min-height: 600px;
}
.my-conversations .tw-min-h-\\[60px\\] {
  min-height: 60px;
}
.my-conversations .tw-w-10 {
  width: 40px;
}
.my-conversations .tw-w-12 {
  width: 48px;
}
.my-conversations .tw-w-16 {
  width: 64px;
}
.my-conversations .tw-w-2 {
  width: 8px;
}
.my-conversations .tw-w-2\\.5 {
  width: 10px;
}
.my-conversations .tw-w-20 {
  width: 80px;
}
.my-conversations .tw-w-3 {
  width: 12px;
}
.my-conversations .tw-w-36 {
  width: 144px;
}
.my-conversations .tw-w-4 {
  width: 16px;
}
.my-conversations .tw-w-48 {
  width: 192px;
}
.my-conversations .tw-w-5 {
  width: 20px;
}
.my-conversations .tw-w-56 {
  width: 224px;
}
.my-conversations .tw-w-6 {
  width: 24px;
}
.my-conversations .tw-w-8 {
  width: 32px;
}
.my-conversations .tw-w-\\[24px\\] {
  width: 24px;
}
.my-conversations .tw-w-\\[520px\\] {
  width: 520px;
}
.my-conversations .tw-w-full {
  width: 100%;
}
.my-conversations .tw-w-px {
  width: 1px;
}
.my-conversations .tw-min-w-0 {
  min-width: 0px;
}
.my-conversations .tw-min-w-\\[16px\\] {
  min-width: 16px;
}
.my-conversations .tw-min-w-\\[20px\\] {
  min-width: 20px;
}
.my-conversations .tw-min-w-\\[24px\\] {
  min-width: 24px;
}
.my-conversations .tw-min-w-\\[360px\\] {
  min-width: 360px;
}
.my-conversations .tw-min-w-\\[40px\\] {
  min-width: 40px;
}
.my-conversations .tw-min-w-\\[50px\\] {
  min-width: 50px;
}
.my-conversations .tw-max-w-7xl {
  max-width: 80rem;
}
.my-conversations .tw-max-w-\\[360px\\] {
  max-width: 360px;
}
.my-conversations .tw-max-w-\\[480px\\] {
  max-width: 480px;
}
.my-conversations .tw-max-w-full {
  max-width: 100%;
}
.my-conversations .tw-max-w-md {
  max-width: 28rem;
}
.my-conversations .tw-max-w-sm {
  max-width: 24rem;
}
.my-conversations .tw-max-w-xs {
  max-width: 20rem;
}
.my-conversations .tw-flex-1 {
  flex: 1 1 0%;
}
.my-conversations .tw-flex-shrink-0 {
  flex-shrink: 0;
}
.my-conversations .\\!tw-translate-x-\\[-50\\%\\] {
  --tw-translate-x: -50% !important;
  transform: translate(-50%, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.my-conversations .-tw-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), -50%) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.my-conversations .tw--translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), -50%) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.my-conversations .tw-rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(180deg) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.my-conversations .tw-transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes tw-pulse {

  50% {
    opacity: .5;
  }
}
.my-conversations .tw-animate-pulse {
  animation: tw-pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes tw-spin {

  to {
    transform: rotate(360deg);
  }
}
.my-conversations .tw-animate-spin {
  animation: tw-spin 1s linear infinite;
}
.my-conversations .tw-cursor-not-allowed {
  cursor: not-allowed;
}
.my-conversations .tw-cursor-pointer {
  cursor: pointer;
}
.my-conversations .tw-grid-cols-12 {
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.my-conversations .tw-grid-cols-8 {
  grid-template-columns: repeat(8, minmax(0, 1fr));
}
.my-conversations .tw-flex-col {
  flex-direction: column;
}
.my-conversations .tw-flex-wrap {
  flex-wrap: wrap;
}
.my-conversations .tw-items-start {
  align-items: flex-start;
}
.my-conversations .tw-items-end {
  align-items: flex-end;
}
.my-conversations .tw-items-center {
  align-items: center;
}
.my-conversations .tw-justify-start {
  justify-content: flex-start;
}
.my-conversations .tw-justify-end {
  justify-content: flex-end;
}
.my-conversations .tw-justify-center {
  justify-content: center;
}
.my-conversations .tw-justify-between {
  justify-content: space-between;
}
.my-conversations .tw-gap-1 {
  gap: 4px;
}
.my-conversations .tw-gap-1\\.5 {
  gap: 6px;
}
.my-conversations .tw-gap-2 {
  gap: 8px;
}
.my-conversations .tw-gap-3 {
  gap: 12px;
}
.my-conversations .tw-gap-4 {
  gap: 16px;
}
.my-conversations .tw-gap-7 {
  gap: 28px;
}
.my-conversations .tw-gap-8 {
  gap: 32px;
}
.my-conversations :is(.tw-space-x-1 > :not([hidden]) ~ :not([hidden])) {
  --tw-space-x-reverse: 0;
  margin-right: calc(4px * 0);
  margin-right: calc(4px * var(--tw-space-x-reverse));
  margin-left: calc(4px * (1 - 0));
  margin-left: calc(4px * (1 - var(--tw-space-x-reverse)));
  margin-left: calc(4px * calc(1 - 0));
  margin-left: calc(4px * calc(1 - var(--tw-space-x-reverse)));
}
.my-conversations :is(.tw-space-x-2 > :not([hidden]) ~ :not([hidden])) {
  --tw-space-x-reverse: 0;
  margin-right: calc(8px * 0);
  margin-right: calc(8px * var(--tw-space-x-reverse));
  margin-left: calc(8px * (1 - 0));
  margin-left: calc(8px * (1 - var(--tw-space-x-reverse)));
  margin-left: calc(8px * calc(1 - 0));
  margin-left: calc(8px * calc(1 - var(--tw-space-x-reverse)));
}
.my-conversations :is(.tw-space-x-3 > :not([hidden]) ~ :not([hidden])) {
  --tw-space-x-reverse: 0;
  margin-right: calc(12px * 0);
  margin-right: calc(12px * var(--tw-space-x-reverse));
  margin-left: calc(12px * (1 - 0));
  margin-left: calc(12px * (1 - var(--tw-space-x-reverse)));
  margin-left: calc(12px * calc(1 - 0));
  margin-left: calc(12px * calc(1 - var(--tw-space-x-reverse)));
}
.my-conversations :is(.tw-space-y-2 > :not([hidden]) ~ :not([hidden])) {
  --tw-space-y-reverse: 0;
  margin-top: calc(8px * (1 - 0));
  margin-top: calc(8px * (1 - var(--tw-space-y-reverse)));
  margin-top: calc(8px * calc(1 - 0));
  margin-top: calc(8px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(8px * 0);
  margin-bottom: calc(8px * var(--tw-space-y-reverse));
}
.my-conversations :is(.tw-space-y-3 > :not([hidden]) ~ :not([hidden])) {
  --tw-space-y-reverse: 0;
  margin-top: calc(12px * (1 - 0));
  margin-top: calc(12px * (1 - var(--tw-space-y-reverse)));
  margin-top: calc(12px * calc(1 - 0));
  margin-top: calc(12px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(12px * 0);
  margin-bottom: calc(12px * var(--tw-space-y-reverse));
}
.my-conversations :is(.tw-space-y-4 > :not([hidden]) ~ :not([hidden])) {
  --tw-space-y-reverse: 0;
  margin-top: calc(16px * (1 - 0));
  margin-top: calc(16px * (1 - var(--tw-space-y-reverse)));
  margin-top: calc(16px * calc(1 - 0));
  margin-top: calc(16px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(16px * 0);
  margin-bottom: calc(16px * var(--tw-space-y-reverse));
}
.my-conversations .tw-self-start {
  align-self: flex-start;
}
.my-conversations .tw-justify-self-end {
  justify-self: end;
}
.my-conversations .tw-overflow-hidden {
  overflow: hidden;
}
.my-conversations .tw-overflow-x-auto {
  overflow-x: auto;
}
.my-conversations .tw-overflow-y-auto {
  overflow-y: auto;
}
.my-conversations .tw-overflow-x-hidden {
  overflow-x: hidden;
}
.my-conversations .tw-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.my-conversations .tw-whitespace-nowrap {
  white-space: nowrap;
}
.my-conversations .tw-whitespace-pre-wrap {
  white-space: pre-wrap;
}
.my-conversations .tw-break-words {
  word-wrap: break-word;
}
.my-conversations .tw-rounded {
  border-radius: 0.25rem;
}
.my-conversations .tw-rounded-2xl {
  border-radius: 1rem;
}
.my-conversations .tw-rounded-full {
  border-radius: 9999px;
}
.my-conversations .tw-rounded-lg {
  border-radius: 0.5rem;
}
.my-conversations .tw-rounded-md {
  border-radius: 0.375rem;
}
.my-conversations .tw-rounded-xl {
  border-radius: 0.75rem;
}
.my-conversations .tw-rounded-b-lg {
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.my-conversations .tw-rounded-t-lg {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.my-conversations .tw-rounded-t-md {
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
}
.my-conversations .tw-border {
  border-width: 1px;
}
.my-conversations .tw-border-0 {
  border-width: 0px;
}
.my-conversations .tw-border-2 {
  border-width: 2px;
}
.my-conversations .tw-border-b {
  border-bottom-width: 1px;
}
.my-conversations .tw-border-b-2 {
  border-bottom-width: 2px;
}
.my-conversations .tw-border-l-4 {
  border-left-width: 4px;
}
.my-conversations .tw-border-r {
  border-right-width: 1px;
}
.my-conversations .tw-border-t {
  border-top-width: 1px;
}
.my-conversations .tw-border-t-\\[5px\\] {
  border-top-width: 5px;
}
.my-conversations .tw-border-solid {
  border-style: solid;
}
.my-conversations .tw-border-none {
  border-style: none;
}
.my-conversations .tw-border-blue-200 {
  --tw-border-opacity: 1;
  border-color: rgba(191, 219, 254, 1);
  border-color: rgba(191, 219, 254, var(--tw-border-opacity, 1));
}
.my-conversations .tw-border-blue-300 {
  --tw-border-opacity: 1;
  border-color: rgba(147, 197, 253, 1);
  border-color: rgba(147, 197, 253, var(--tw-border-opacity, 1));
}
.my-conversations .tw-border-blue-400 {
  --tw-border-opacity: 1;
  border-color: rgba(96, 165, 250, 1);
  border-color: rgba(96, 165, 250, var(--tw-border-opacity, 1));
}
.my-conversations .tw-border-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgba(59, 130, 246, 1);
  border-color: rgba(59, 130, 246, var(--tw-border-opacity, 1));
}
.my-conversations .tw-border-cfo-blue-600 {
  --tw-border-opacity: 1;
  border-color: rgba(80, 129, 255, 1);
  border-color: rgba(80, 129, 255, var(--tw-border-opacity, 1));
}
.my-conversations .tw-border-cfo-grey-600 {
  --tw-border-opacity: 1;
  border-color: rgba(153, 153, 153, 1);
  border-color: rgba(153, 153, 153, var(--tw-border-opacity, 1));
}
.my-conversations .tw-border-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgba(243, 244, 246, 1);
  border-color: rgba(243, 244, 246, var(--tw-border-opacity, 1));
}
.my-conversations .tw-border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgba(229, 231, 235, 1);
  border-color: rgba(229, 231, 235, var(--tw-border-opacity, 1));
}
.my-conversations .tw-border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgba(209, 213, 219, 1);
  border-color: rgba(209, 213, 219, var(--tw-border-opacity, 1));
}
.my-conversations .tw-border-gray-500 {
  --tw-border-opacity: 1;
  border-color: rgba(107, 114, 128, 1);
  border-color: rgba(107, 114, 128, var(--tw-border-opacity, 1));
}
.my-conversations .tw-border-green-300 {
  --tw-border-opacity: 1;
  border-color: rgba(134, 239, 172, 1);
  border-color: rgba(134, 239, 172, var(--tw-border-opacity, 1));
}
.my-conversations .tw-border-green-500 {
  --tw-border-opacity: 1;
  border-color: rgba(34, 197, 94, 1);
  border-color: rgba(34, 197, 94, var(--tw-border-opacity, 1));
}
.my-conversations .tw-border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgba(239, 68, 68, 1);
  border-color: rgba(239, 68, 68, var(--tw-border-opacity, 1));
}
.my-conversations .tw-border-transparent {
  border-color: transparent;
}
.my-conversations .tw-border-white {
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, 1);
  border-color: rgba(255, 255, 255, var(--tw-border-opacity, 1));
}
.my-conversations .tw-border-yellow-400 {
  --tw-border-opacity: 1;
  border-color: rgba(250, 204, 21, 1);
  border-color: rgba(250, 204, 21, var(--tw-border-opacity, 1));
}
.my-conversations .tw-border-b-cfo-grey-400 {
  --tw-border-opacity: 1;
  border-bottom-color: rgba(196, 196, 196, 1);
  border-bottom-color: rgba(196, 196, 196, var(--tw-border-opacity, 1));
}
.my-conversations .tw-border-b-cfo-grey-600 {
  --tw-border-opacity: 1;
  border-bottom-color: rgba(153, 153, 153, 1);
  border-bottom-color: rgba(153, 153, 153, var(--tw-border-opacity, 1));
}
.my-conversations .tw-border-l-cfo-blue-600 {
  --tw-border-opacity: 1;
  border-left-color: rgba(80, 129, 255, 1);
  border-left-color: rgba(80, 129, 255, var(--tw-border-opacity, 1));
}
.my-conversations .tw-border-t-cfo-blue-600 {
  --tw-border-opacity: 1;
  border-top-color: rgba(80, 129, 255, 1);
  border-top-color: rgba(80, 129, 255, var(--tw-border-opacity, 1));
}
.my-conversations .\\!tw-bg-cfo-grey-600 {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(153, 153, 153, 1) !important;
  background-color: rgba(153, 153, 153, var(--tw-bg-opacity, 1)) !important;
}
.my-conversations .tw-bg-\\[\\#F4F6FA\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(244, 246, 250, 1);
  background-color: rgba(244, 246, 250, var(--tw-bg-opacity, 1));
}
.my-conversations .tw-bg-black {
  --tw-bg-opacity: 1;
  background-color: rgba(0, 0, 0, 1);
  background-color: rgba(0, 0, 0, var(--tw-bg-opacity, 1));
}
.my-conversations .tw-bg-black\\/40 {
  background-color: rgba(0, 0, 0, 0.4);
}
.my-conversations .tw-bg-black\\/50 {
  background-color: rgba(0, 0, 0, 0.5);
}
.my-conversations .tw-bg-blue-100 {
  --tw-bg-opacity: 1;
  background-color: rgba(219, 234, 254, 1);
  background-color: rgba(219, 234, 254, var(--tw-bg-opacity, 1));
}
.my-conversations .tw-bg-blue-50 {
  --tw-bg-opacity: 1;
  background-color: rgba(239, 246, 255, 1);
  background-color: rgba(239, 246, 255, var(--tw-bg-opacity, 1));
}
.my-conversations .tw-bg-cfo-blue-100 {
  --tw-bg-opacity: 1;
  background-color: rgba(248, 250, 255, 1);
  background-color: rgba(248, 250, 255, var(--tw-bg-opacity, 1));
}
.my-conversations .tw-bg-cfo-blue-600 {
  --tw-bg-opacity: 1;
  background-color: rgba(80, 129, 255, 1);
  background-color: rgba(80, 129, 255, var(--tw-bg-opacity, 1));
}
.my-conversations .tw-bg-cfo-blue-700 {
  --tw-bg-opacity: 1;
  background-color: rgba(74, 103, 220, 1);
  background-color: rgba(74, 103, 220, var(--tw-bg-opacity, 1));
}
.my-conversations .tw-bg-cfo-green-300 {
  --tw-bg-opacity: 1;
  background-color: rgba(22, 220, 56, 1);
  background-color: rgba(22, 220, 56, var(--tw-bg-opacity, 1));
}
.my-conversations .tw-bg-cfo-red-400 {
  --tw-bg-opacity: 1;
  background-color: rgba(211, 74, 70, 1);
  background-color: rgba(211, 74, 70, var(--tw-bg-opacity, 1));
}
.my-conversations .tw-bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgba(243, 244, 246, 1);
  background-color: rgba(243, 244, 246, var(--tw-bg-opacity, 1));
}
.my-conversations .tw-bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgba(229, 231, 235, 1);
  background-color: rgba(229, 231, 235, var(--tw-bg-opacity, 1));
}
.my-conversations .tw-bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgba(209, 213, 219, 1);
  background-color: rgba(209, 213, 219, var(--tw-bg-opacity, 1));
}
.my-conversations .tw-bg-gray-400 {
  --tw-bg-opacity: 1;
  background-color: rgba(156, 163, 175, 1);
  background-color: rgba(156, 163, 175, var(--tw-bg-opacity, 1));
}
.my-conversations .tw-bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgba(249, 250, 251, 1);
  background-color: rgba(249, 250, 251, var(--tw-bg-opacity, 1));
}
.my-conversations .tw-bg-green-100 {
  --tw-bg-opacity: 1;
  background-color: rgba(220, 252, 231, 1);
  background-color: rgba(220, 252, 231, var(--tw-bg-opacity, 1));
}
.my-conversations .tw-bg-green-400 {
  --tw-bg-opacity: 1;
  background-color: rgba(74, 222, 128, 1);
  background-color: rgba(74, 222, 128, var(--tw-bg-opacity, 1));
}
.my-conversations .tw-bg-green-50 {
  --tw-bg-opacity: 1;
  background-color: rgba(240, 253, 244, 1);
  background-color: rgba(240, 253, 244, var(--tw-bg-opacity, 1));
}
.my-conversations .tw-bg-green-500 {
  --tw-bg-opacity: 1;
  background-color: rgba(34, 197, 94, 1);
  background-color: rgba(34, 197, 94, var(--tw-bg-opacity, 1));
}
.my-conversations .tw-bg-green-600 {
  --tw-bg-opacity: 1;
  background-color: rgba(22, 163, 74, 1);
  background-color: rgba(22, 163, 74, var(--tw-bg-opacity, 1));
}
.my-conversations .tw-bg-orange-100 {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 237, 213, 1);
  background-color: rgba(255, 237, 213, var(--tw-bg-opacity, 1));
}
.my-conversations .tw-bg-orange-50 {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 247, 237, 1);
  background-color: rgba(255, 247, 237, var(--tw-bg-opacity, 1));
}
.my-conversations .tw-bg-red-100 {
  --tw-bg-opacity: 1;
  background-color: rgba(254, 226, 226, 1);
  background-color: rgba(254, 226, 226, var(--tw-bg-opacity, 1));
}
.my-conversations .tw-bg-red-50 {
  --tw-bg-opacity: 1;
  background-color: rgba(254, 242, 242, 1);
  background-color: rgba(254, 242, 242, var(--tw-bg-opacity, 1));
}
.my-conversations .tw-bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgba(239, 68, 68, 1);
  background-color: rgba(239, 68, 68, var(--tw-bg-opacity, 1));
}
.my-conversations .tw-bg-transparent {
  background-color: transparent;
}
.my-conversations .tw-bg-white {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity, 1));
}
.my-conversations .tw-bg-white\\/20 {
  background-color: rgba(255, 255, 255, 0.2);
}
.my-conversations .tw-bg-white\\/30 {
  background-color: rgba(255, 255, 255, 0.3);
}
.my-conversations .tw-bg-white\\/80 {
  background-color: rgba(255, 255, 255, 0.8);
}
.my-conversations .tw-bg-yellow-100 {
  --tw-bg-opacity: 1;
  background-color: rgba(254, 249, 195, 1);
  background-color: rgba(254, 249, 195, var(--tw-bg-opacity, 1));
}
.my-conversations .tw-bg-yellow-200 {
  --tw-bg-opacity: 1;
  background-color: rgba(254, 240, 138, 1);
  background-color: rgba(254, 240, 138, var(--tw-bg-opacity, 1));
}
.my-conversations .tw-bg-yellow-400 {
  --tw-bg-opacity: 1;
  background-color: rgba(250, 204, 21, 1);
  background-color: rgba(250, 204, 21, var(--tw-bg-opacity, 1));
}
.my-conversations .tw-bg-yellow-50 {
  --tw-bg-opacity: 1;
  background-color: rgba(254, 252, 232, 1);
  background-color: rgba(254, 252, 232, var(--tw-bg-opacity, 1));
}
.my-conversations .tw-bg-yellow-500 {
  --tw-bg-opacity: 1;
  background-color: rgba(234, 179, 8, 1);
  background-color: rgba(234, 179, 8, var(--tw-bg-opacity, 1));
}
.my-conversations .tw-bg-opacity-20 {
  --tw-bg-opacity: 0.2;
}
.my-conversations .tw-bg-opacity-25 {
  --tw-bg-opacity: 0.25;
}
.my-conversations .tw-bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}
.my-conversations .tw-bg-opacity-90 {
  --tw-bg-opacity: 0.9;
}
.my-conversations .tw-bg-cfo-gradient-blue {
  background-image: linear-gradient(180deg,#4A67DC_50%,#5081FF_79.17%,#3CBDEB_100%);
}
.my-conversations .tw-object-contain {
  -o-object-fit: contain;
     object-fit: contain;
}
.my-conversations .tw-object-cover {
  -o-object-fit: cover;
     object-fit: cover;
}
.my-conversations .tw-p-0 {
  padding: 0px;
}
.my-conversations .tw-p-1 {
  padding: 4px;
}
.my-conversations .tw-p-2 {
  padding: 8px;
}
.my-conversations .tw-p-3 {
  padding: 12px;
}
.my-conversations .tw-p-4 {
  padding: 16px;
}
.my-conversations .tw-p-6 {
  padding: 24px;
}
.my-conversations .tw-p-8 {
  padding: 32px;
}
.my-conversations .tw-px-1 {
  padding-left: 4px;
  padding-right: 4px;
}
.my-conversations .tw-px-1\\.5 {
  padding-left: 6px;
  padding-right: 6px;
}
.my-conversations .tw-px-2 {
  padding-left: 8px;
  padding-right: 8px;
}
.my-conversations .tw-px-3 {
  padding-left: 12px;
  padding-right: 12px;
}
.my-conversations .tw-px-4 {
  padding-left: 16px;
  padding-right: 16px;
}
.my-conversations .tw-px-5 {
  padding-left: 20px;
  padding-right: 20px;
}
.my-conversations .tw-px-6 {
  padding-left: 24px;
  padding-right: 24px;
}
.my-conversations .tw-px-8 {
  padding-left: 32px;
  padding-right: 32px;
}
.my-conversations .tw-px-\\[20\\%\\] {
  padding-left: 20%;
  padding-right: 20%;
}
.my-conversations .tw-py-0\\.5 {
  padding-top: 2px;
  padding-bottom: 2px;
}
.my-conversations .tw-py-1 {
  padding-top: 4px;
  padding-bottom: 4px;
}
.my-conversations .tw-py-1\\.5 {
  padding-top: 6px;
  padding-bottom: 6px;
}
.my-conversations .tw-py-2 {
  padding-top: 8px;
  padding-bottom: 8px;
}
.my-conversations .tw-py-2\\.5 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.my-conversations .tw-py-3 {
  padding-top: 12px;
  padding-bottom: 12px;
}
.my-conversations .tw-py-4 {
  padding-top: 16px;
  padding-bottom: 16px;
}
.my-conversations .tw-py-6 {
  padding-top: 24px;
  padding-bottom: 24px;
}
.my-conversations .tw-py-8 {
  padding-top: 32px;
  padding-bottom: 32px;
}
.my-conversations .tw-py-\\[8px\\] {
  padding-top: 8px;
  padding-bottom: 8px;
}
.my-conversations .tw-pb-2 {
  padding-bottom: 8px;
}
.my-conversations .tw-pb-4 {
  padding-bottom: 16px;
}
.my-conversations .tw-pb-6 {
  padding-bottom: 24px;
}
.my-conversations .tw-pb-8 {
  padding-bottom: 32px;
}
.my-conversations .tw-pb-\\[2px\\] {
  padding-bottom: 2px;
}
.my-conversations .tw-pl-10 {
  padding-left: 40px;
}
.my-conversations .tw-pl-2 {
  padding-left: 8px;
}
.my-conversations .tw-pl-3 {
  padding-left: 12px;
}
.my-conversations .tw-pl-4 {
  padding-left: 16px;
}
.my-conversations .tw-pl-6 {
  padding-left: 24px;
}
.my-conversations .tw-pr-10 {
  padding-right: 40px;
}
.my-conversations .tw-pr-16 {
  padding-right: 64px;
}
.my-conversations .tw-pr-4 {
  padding-right: 16px;
}
.my-conversations .tw-pt-0 {
  padding-top: 0px;
}
.my-conversations .tw-pt-1 {
  padding-top: 4px;
}
.my-conversations .tw-pt-2 {
  padding-top: 8px;
}
.my-conversations .tw-pt-4 {
  padding-top: 16px;
}
.my-conversations .tw-pt-6 {
  padding-top: 24px;
}
.my-conversations .tw-text-left {
  text-align: left;
}
.my-conversations .tw-text-center {
  text-align: center;
}
.my-conversations .tw-text-right {
  text-align: right;
}
.my-conversations .tw-font-brandonTextBold {
  font-family: Brandon Text Bold, Helvetica, Arial, sans-serif;
}
.my-conversations .tw-font-brandonTextMedium {
  font-family: Brandon Text Medium, Helvetica, Arial, sans-serif;
}
.my-conversations .tw-font-brandonTextRegular {
  font-family: Brandon Text, Helvetica, Arial, sans-serif;
}
.my-conversations .tw-text-2xl {
  font-size: 24px;
}
.my-conversations .tw-text-3xl {
  font-size: 30px;
}
.my-conversations .tw-text-4xl {
  font-size: 36px;
}
.my-conversations .tw-text-5xl {
  font-size: 48px;
}
.my-conversations .tw-text-6xl {
  font-size: 60px;
}
.my-conversations .tw-text-\\[10px\\] {
  font-size: 10px;
}
.my-conversations .tw-text-\\[12px\\] {
  font-size: 12px;
}
.my-conversations .tw-text-\\[13px\\] {
  font-size: 13px;
}
.my-conversations .tw-text-\\[14px\\] {
  font-size: 14px;
}
.my-conversations .tw-text-\\[15px\\] {
  font-size: 15px;
}
.my-conversations .tw-text-\\[16px\\] {
  font-size: 16px;
}
.my-conversations .tw-text-\\[18px\\] {
  font-size: 18px;
}
.my-conversations .tw-text-\\[24px\\] {
  font-size: 24px;
}
.my-conversations .tw-text-base {
  font-size: 16px;
}
.my-conversations .tw-text-lg {
  font-size: 18px;
}
.my-conversations .tw-text-sm {
  font-size: 14px;
}
.my-conversations .tw-text-xl {
  font-size: 20px;
}
.my-conversations .tw-text-xs {
  font-size: 12px;
}
.my-conversations .tw-font-medium {
  font-weight: 500;
}
.my-conversations .tw-font-semibold {
  font-weight: 600;
}
.my-conversations .tw-uppercase {
  text-transform: uppercase;
}
.my-conversations .tw-capitalize {
  text-transform: capitalize;
}
.my-conversations .tw-italic {
  font-style: italic;
}
.my-conversations .tw-leading-7 {
  line-height: 1.75rem;
}
.my-conversations .tw-leading-\\[2\\.5rem\\] {
  line-height: 2.5rem;
}
.my-conversations .tw-tracking-wide {
  letter-spacing: 0.025em;
}
.my-conversations .tw-text-black {
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, 1);
  color: rgba(0, 0, 0, var(--tw-text-opacity, 1));
}
.my-conversations .tw-text-blue-100 {
  --tw-text-opacity: 1;
  color: rgba(219, 234, 254, 1);
  color: rgba(219, 234, 254, var(--tw-text-opacity, 1));
}
.my-conversations .tw-text-blue-200 {
  --tw-text-opacity: 1;
  color: rgba(191, 219, 254, 1);
  color: rgba(191, 219, 254, var(--tw-text-opacity, 1));
}
.my-conversations .tw-text-blue-500 {
  --tw-text-opacity: 1;
  color: rgba(59, 130, 246, 1);
  color: rgba(59, 130, 246, var(--tw-text-opacity, 1));
}
.my-conversations .tw-text-blue-600 {
  --tw-text-opacity: 1;
  color: rgba(37, 99, 235, 1);
  color: rgba(37, 99, 235, var(--tw-text-opacity, 1));
}
.my-conversations .tw-text-blue-700 {
  --tw-text-opacity: 1;
  color: rgba(29, 78, 216, 1);
  color: rgba(29, 78, 216, var(--tw-text-opacity, 1));
}
.my-conversations .tw-text-blue-800 {
  --tw-text-opacity: 1;
  color: rgba(30, 64, 175, 1);
  color: rgba(30, 64, 175, var(--tw-text-opacity, 1));
}
.my-conversations .tw-text-cfo-black {
  --tw-text-opacity: 1;
  color: rgba(65, 74, 79, 1);
  color: rgba(65, 74, 79, var(--tw-text-opacity, 1));
}
.my-conversations .tw-text-cfo-blue-600 {
  --tw-text-opacity: 1;
  color: rgba(80, 129, 255, 1);
  color: rgba(80, 129, 255, var(--tw-text-opacity, 1));
}
.my-conversations .tw-text-cfo-blue-700 {
  --tw-text-opacity: 1;
  color: rgba(74, 103, 220, 1);
  color: rgba(74, 103, 220, var(--tw-text-opacity, 1));
}
.my-conversations .tw-text-cfo-grey-600 {
  --tw-text-opacity: 1;
  color: rgba(153, 153, 153, 1);
  color: rgba(153, 153, 153, var(--tw-text-opacity, 1));
}
.my-conversations .tw-text-cfo-red-400 {
  --tw-text-opacity: 1;
  color: rgba(211, 74, 70, 1);
  color: rgba(211, 74, 70, var(--tw-text-opacity, 1));
}
.my-conversations .tw-text-gray-300 {
  --tw-text-opacity: 1;
  color: rgba(209, 213, 219, 1);
  color: rgba(209, 213, 219, var(--tw-text-opacity, 1));
}
.my-conversations .tw-text-gray-400 {
  --tw-text-opacity: 1;
  color: rgba(156, 163, 175, 1);
  color: rgba(156, 163, 175, var(--tw-text-opacity, 1));
}
.my-conversations .tw-text-gray-500 {
  --tw-text-opacity: 1;
  color: rgba(107, 114, 128, 1);
  color: rgba(107, 114, 128, var(--tw-text-opacity, 1));
}
.my-conversations .tw-text-gray-600 {
  --tw-text-opacity: 1;
  color: rgba(75, 85, 99, 1);
  color: rgba(75, 85, 99, var(--tw-text-opacity, 1));
}
.my-conversations .tw-text-gray-700 {
  --tw-text-opacity: 1;
  color: rgba(55, 65, 81, 1);
  color: rgba(55, 65, 81, var(--tw-text-opacity, 1));
}
.my-conversations .tw-text-gray-800 {
  --tw-text-opacity: 1;
  color: rgba(31, 41, 55, 1);
  color: rgba(31, 41, 55, var(--tw-text-opacity, 1));
}
.my-conversations .tw-text-gray-900 {
  --tw-text-opacity: 1;
  color: rgba(17, 24, 39, 1);
  color: rgba(17, 24, 39, var(--tw-text-opacity, 1));
}
.my-conversations .tw-text-green-500 {
  --tw-text-opacity: 1;
  color: rgba(34, 197, 94, 1);
  color: rgba(34, 197, 94, var(--tw-text-opacity, 1));
}
.my-conversations .tw-text-green-600 {
  --tw-text-opacity: 1;
  color: rgba(22, 163, 74, 1);
  color: rgba(22, 163, 74, var(--tw-text-opacity, 1));
}
.my-conversations .tw-text-green-700 {
  --tw-text-opacity: 1;
  color: rgba(21, 128, 61, 1);
  color: rgba(21, 128, 61, var(--tw-text-opacity, 1));
}
.my-conversations .tw-text-orange-600 {
  --tw-text-opacity: 1;
  color: rgba(234, 88, 12, 1);
  color: rgba(234, 88, 12, var(--tw-text-opacity, 1));
}
.my-conversations .tw-text-red-400 {
  --tw-text-opacity: 1;
  color: rgba(248, 113, 113, 1);
  color: rgba(248, 113, 113, var(--tw-text-opacity, 1));
}
.my-conversations .tw-text-red-500 {
  --tw-text-opacity: 1;
  color: rgba(239, 68, 68, 1);
  color: rgba(239, 68, 68, var(--tw-text-opacity, 1));
}
.my-conversations .tw-text-red-600 {
  --tw-text-opacity: 1;
  color: rgba(220, 38, 38, 1);
  color: rgba(220, 38, 38, var(--tw-text-opacity, 1));
}
.my-conversations .tw-text-white {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity, 1));
}
.my-conversations .tw-text-white\\/80 {
  color: rgba(255, 255, 255, 0.8);
}
.my-conversations .tw-text-yellow-500 {
  --tw-text-opacity: 1;
  color: rgba(234, 179, 8, 1);
  color: rgba(234, 179, 8, var(--tw-text-opacity, 1));
}
.my-conversations .tw-text-yellow-600 {
  --tw-text-opacity: 1;
  color: rgba(202, 138, 4, 1);
  color: rgba(202, 138, 4, var(--tw-text-opacity, 1));
}
.my-conversations .tw-text-yellow-700 {
  --tw-text-opacity: 1;
  color: rgba(161, 98, 7, 1);
  color: rgba(161, 98, 7, var(--tw-text-opacity, 1));
}
.my-conversations .tw-text-yellow-800 {
  --tw-text-opacity: 1;
  color: rgba(133, 77, 14, 1);
  color: rgba(133, 77, 14, var(--tw-text-opacity, 1));
}
.my-conversations .tw-underline {
  text-decoration-line: underline;
}
.my-conversations .tw-placeholder-gray-500::-moz-placeholder {
  --tw-placeholder-opacity: 1;
  color: rgba(107, 114, 128, 1);
  color: rgba(107, 114, 128, var(--tw-placeholder-opacity, 1));
}
.my-conversations .tw-placeholder-gray-500::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgba(107, 114, 128, 1);
  color: rgba(107, 114, 128, var(--tw-placeholder-opacity, 1));
}
.my-conversations .tw-opacity-0 {
  opacity: 0;
}
.my-conversations .tw-opacity-100 {
  opacity: 1;
}
.my-conversations .tw-opacity-50 {
  opacity: 0.5;
}
.my-conversations .tw-opacity-70 {
  opacity: 0.7;
}
.my-conversations .tw-opacity-75 {
  opacity: 0.75;
}
.my-conversations .tw-opacity-90 {
  opacity: 0.9;
}
.my-conversations .tw-shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.my-conversations .tw-shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.my-conversations .tw-shadow-md {
  --tw-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.my-conversations .tw-shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.my-conversations .tw-shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.my-conversations .tw-outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.my-conversations .tw-ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
.my-conversations .tw-ring-4 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
.my-conversations .tw-ring-blue-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(147, 197, 253, var(--tw-ring-opacity, 1));
}
.my-conversations .tw-ring-blue-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(96, 165, 250, var(--tw-ring-opacity, 1));
}
.my-conversations .tw-ring-opacity-50 {
  --tw-ring-opacity: 0.5;
}
.my-conversations .tw-transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.my-conversations .tw-transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.my-conversations .tw-transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.my-conversations .tw-transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.my-conversations .tw-transition-shadow {
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.my-conversations .tw-transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.my-conversations .tw-duration-200 {
  transition-duration: 200ms;
}
.my-conversations .tw-duration-300 {
  transition-duration: 300ms;
}

/* This file builds a namespaced Tailwind bundle scoped under the
   .my-conversations selector (see \`important\` in the companion config).
   Import this once in the app root so the scoped utilities are always
   available when navigating client-side. */

.my-conversations .placeholder\\:tw-text-gray-400::-moz-placeholder {
  --tw-text-opacity: 1;
  color: rgba(156, 163, 175, 1);
  color: rgba(156, 163, 175, var(--tw-text-opacity, 1));
}

.my-conversations .placeholder\\:tw-text-gray-400::placeholder {
  --tw-text-opacity: 1;
  color: rgba(156, 163, 175, 1);
  color: rgba(156, 163, 175, var(--tw-text-opacity, 1));
}

.my-conversations .last\\:tw-border-0:last-child {
  border-width: 0px;
}

.my-conversations .hover\\:tw-scale-110:hover {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1.1) scaleY(1.1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.my-conversations .hover\\:tw-border-blue-200:hover {
  --tw-border-opacity: 1;
  border-color: rgba(191, 219, 254, 1);
  border-color: rgba(191, 219, 254, var(--tw-border-opacity, 1));
}

.my-conversations .hover\\:tw-border-blue-300:hover {
  --tw-border-opacity: 1;
  border-color: rgba(147, 197, 253, 1);
  border-color: rgba(147, 197, 253, var(--tw-border-opacity, 1));
}

.my-conversations .hover\\:tw-border-blue-400:hover {
  --tw-border-opacity: 1;
  border-color: rgba(96, 165, 250, 1);
  border-color: rgba(96, 165, 250, var(--tw-border-opacity, 1));
}

.my-conversations .hover\\:tw-border-cfo-blue-600:hover {
  --tw-border-opacity: 1;
  border-color: rgba(80, 129, 255, 1);
  border-color: rgba(80, 129, 255, var(--tw-border-opacity, 1));
}

.my-conversations .hover\\:tw-border-gray-300:hover {
  --tw-border-opacity: 1;
  border-color: rgba(209, 213, 219, 1);
  border-color: rgba(209, 213, 219, var(--tw-border-opacity, 1));
}

.my-conversations .hover\\:tw-border-green-300:hover {
  --tw-border-opacity: 1;
  border-color: rgba(134, 239, 172, 1);
  border-color: rgba(134, 239, 172, var(--tw-border-opacity, 1));
}

.my-conversations .hover\\:tw-border-orange-300:hover {
  --tw-border-opacity: 1;
  border-color: rgba(253, 186, 116, 1);
  border-color: rgba(253, 186, 116, var(--tw-border-opacity, 1));
}

.my-conversations .hover\\:tw-border-red-200:hover {
  --tw-border-opacity: 1;
  border-color: rgba(254, 202, 202, 1);
  border-color: rgba(254, 202, 202, var(--tw-border-opacity, 1));
}

.my-conversations .hover\\:tw-border-red-300:hover {
  --tw-border-opacity: 1;
  border-color: rgba(252, 165, 165, 1);
  border-color: rgba(252, 165, 165, var(--tw-border-opacity, 1));
}

.my-conversations .hover\\:tw-border-yellow-300:hover {
  --tw-border-opacity: 1;
  border-color: rgba(253, 224, 71, 1);
  border-color: rgba(253, 224, 71, var(--tw-border-opacity, 1));
}

.my-conversations .hover\\:tw-bg-blue-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(219, 234, 254, 1);
  background-color: rgba(219, 234, 254, var(--tw-bg-opacity, 1));
}

.my-conversations .hover\\:tw-bg-blue-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(191, 219, 254, 1);
  background-color: rgba(191, 219, 254, var(--tw-bg-opacity, 1));
}

.my-conversations .hover\\:tw-bg-blue-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(239, 246, 255, 1);
  background-color: rgba(239, 246, 255, var(--tw-bg-opacity, 1));
}

.my-conversations .hover\\:tw-bg-cfo-blue-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(248, 250, 255, 1);
  background-color: rgba(248, 250, 255, var(--tw-bg-opacity, 1));
}

.my-conversations .hover\\:tw-bg-cfo-blue-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(74, 103, 220, 1);
  background-color: rgba(74, 103, 220, var(--tw-bg-opacity, 1));
}

.my-conversations .hover\\:tw-bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(243, 244, 246, 1);
  background-color: rgba(243, 244, 246, var(--tw-bg-opacity, 1));
}

.my-conversations .hover\\:tw-bg-gray-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(229, 231, 235, 1);
  background-color: rgba(229, 231, 235, var(--tw-bg-opacity, 1));
}

.my-conversations .hover\\:tw-bg-gray-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(249, 250, 251, 1);
  background-color: rgba(249, 250, 251, var(--tw-bg-opacity, 1));
}

.my-conversations .hover\\:tw-bg-green-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(220, 252, 231, 1);
  background-color: rgba(220, 252, 231, var(--tw-bg-opacity, 1));
}

.my-conversations .hover\\:tw-bg-green-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(240, 253, 244, 1);
  background-color: rgba(240, 253, 244, var(--tw-bg-opacity, 1));
}

.my-conversations .hover\\:tw-bg-green-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(21, 128, 61, 1);
  background-color: rgba(21, 128, 61, var(--tw-bg-opacity, 1));
}

.my-conversations .hover\\:tw-bg-orange-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 237, 213, 1);
  background-color: rgba(255, 237, 213, var(--tw-bg-opacity, 1));
}

.my-conversations .hover\\:tw-bg-orange-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 247, 237, 1);
  background-color: rgba(255, 247, 237, var(--tw-bg-opacity, 1));
}

.my-conversations .hover\\:tw-bg-red-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(254, 226, 226, 1);
  background-color: rgba(254, 226, 226, var(--tw-bg-opacity, 1));
}

.my-conversations .hover\\:tw-bg-red-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(254, 242, 242, 1);
  background-color: rgba(254, 242, 242, var(--tw-bg-opacity, 1));
}

.my-conversations .hover\\:tw-bg-white:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity, 1));
}

.my-conversations .hover\\:tw-bg-white\\/20:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.my-conversations .hover\\:tw-bg-yellow-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(254, 249, 195, 1);
  background-color: rgba(254, 249, 195, var(--tw-bg-opacity, 1));
}

.my-conversations .hover\\:tw-bg-yellow-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(254, 252, 232, 1);
  background-color: rgba(254, 252, 232, var(--tw-bg-opacity, 1));
}

.my-conversations .hover\\:tw-bg-opacity-20:hover {
  --tw-bg-opacity: 0.2;
}

.my-conversations .hover\\:tw-bg-opacity-70:hover {
  --tw-bg-opacity: 0.7;
}

.my-conversations .hover\\:tw-bg-opacity-75:hover {
  --tw-bg-opacity: 0.75;
}

.my-conversations .hover\\:tw-text-blue-600:hover {
  --tw-text-opacity: 1;
  color: rgba(37, 99, 235, 1);
  color: rgba(37, 99, 235, var(--tw-text-opacity, 1));
}

.my-conversations .hover\\:tw-text-blue-700:hover {
  --tw-text-opacity: 1;
  color: rgba(29, 78, 216, 1);
  color: rgba(29, 78, 216, var(--tw-text-opacity, 1));
}

.my-conversations .hover\\:tw-text-blue-800:hover {
  --tw-text-opacity: 1;
  color: rgba(30, 64, 175, 1);
  color: rgba(30, 64, 175, var(--tw-text-opacity, 1));
}

.my-conversations .hover\\:tw-text-blue-900:hover {
  --tw-text-opacity: 1;
  color: rgba(30, 58, 138, 1);
  color: rgba(30, 58, 138, var(--tw-text-opacity, 1));
}

.my-conversations .hover\\:tw-text-cfo-blue-600:hover {
  --tw-text-opacity: 1;
  color: rgba(80, 129, 255, 1);
  color: rgba(80, 129, 255, var(--tw-text-opacity, 1));
}

.my-conversations .hover\\:tw-text-cfo-blue-700:hover {
  --tw-text-opacity: 1;
  color: rgba(74, 103, 220, 1);
  color: rgba(74, 103, 220, var(--tw-text-opacity, 1));
}

.my-conversations .hover\\:tw-text-gray-600:hover {
  --tw-text-opacity: 1;
  color: rgba(75, 85, 99, 1);
  color: rgba(75, 85, 99, var(--tw-text-opacity, 1));
}

.my-conversations .hover\\:tw-text-gray-700:hover {
  --tw-text-opacity: 1;
  color: rgba(55, 65, 81, 1);
  color: rgba(55, 65, 81, var(--tw-text-opacity, 1));
}

.my-conversations .hover\\:tw-text-gray-800:hover {
  --tw-text-opacity: 1;
  color: rgba(31, 41, 55, 1);
  color: rgba(31, 41, 55, var(--tw-text-opacity, 1));
}

.my-conversations .hover\\:tw-text-green-700:hover {
  --tw-text-opacity: 1;
  color: rgba(21, 128, 61, 1);
  color: rgba(21, 128, 61, var(--tw-text-opacity, 1));
}

.my-conversations .hover\\:tw-text-red-500:hover {
  --tw-text-opacity: 1;
  color: rgba(239, 68, 68, 1);
  color: rgba(239, 68, 68, var(--tw-text-opacity, 1));
}

.my-conversations .hover\\:tw-text-red-600:hover {
  --tw-text-opacity: 1;
  color: rgba(220, 38, 38, 1);
  color: rgba(220, 38, 38, var(--tw-text-opacity, 1));
}

.my-conversations .hover\\:tw-text-red-700:hover {
  --tw-text-opacity: 1;
  color: rgba(185, 28, 28, 1);
  color: rgba(185, 28, 28, var(--tw-text-opacity, 1));
}

.my-conversations .hover\\:tw-text-white:hover {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity, 1));
}

.my-conversations .hover\\:tw-text-yellow-800:hover {
  --tw-text-opacity: 1;
  color: rgba(133, 77, 14, 1);
  color: rgba(133, 77, 14, var(--tw-text-opacity, 1));
}

.my-conversations .hover\\:tw-underline:hover {
  text-decoration-line: underline;
}

.my-conversations .hover\\:tw-opacity-75:hover {
  opacity: 0.75;
}

.my-conversations .hover\\:tw-opacity-80:hover {
  opacity: 0.8;
}

.my-conversations .hover\\:tw-shadow-md:hover {
  --tw-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}

.my-conversations .focus\\:tw-border-blue-500:focus {
  --tw-border-opacity: 1;
  border-color: rgba(59, 130, 246, 1);
  border-color: rgba(59, 130, 246, var(--tw-border-opacity, 1));
}

.my-conversations .focus\\:tw-border-cfo-blue-500:focus {
  --tw-border-opacity: 1;
  border-color: rgba(60, 189, 235, 1);
  border-color: rgba(60, 189, 235, var(--tw-border-opacity, 1));
}

.my-conversations .focus\\:tw-border-red-500:focus {
  --tw-border-opacity: 1;
  border-color: rgba(239, 68, 68, 1);
  border-color: rgba(239, 68, 68, var(--tw-border-opacity, 1));
}

.my-conversations .focus\\:tw-border-transparent:focus {
  border-color: transparent;
}

.my-conversations .focus\\:tw-bg-white:focus {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity, 1));
}

.my-conversations .focus\\:tw-outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.my-conversations .focus\\:tw-ring-1:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}

.my-conversations .focus\\:tw-ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}

.my-conversations .focus\\:tw-ring-blue-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(59, 130, 246, var(--tw-ring-opacity, 1));
}

.my-conversations .focus\\:tw-ring-cfo-blue-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(60, 189, 235, var(--tw-ring-opacity, 1));
}

.my-conversations .focus\\:tw-ring-red-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(239, 68, 68, var(--tw-ring-opacity, 1));
}

.my-conversations .disabled\\:tw-cursor-not-allowed:disabled {
  cursor: not-allowed;
}

.my-conversations .disabled\\:tw-bg-gray-300:disabled {
  --tw-bg-opacity: 1;
  background-color: rgba(209, 213, 219, 1);
  background-color: rgba(209, 213, 219, var(--tw-bg-opacity, 1));
}

.my-conversations .disabled\\:tw-opacity-50:disabled {
  opacity: 0.5;
}

.my-conversations :is(.tw-group:hover .group-hover\\:tw-opacity-100) {
  opacity: 1;
}

@media (min-width: 768px) {

  .my-conversations .md\\:tw-flex {
    display: flex;
  }

  .my-conversations .md\\:tw-hidden {
    display: none;
  }
}

@media (min-width: 1024px) {

  .my-conversations .lg\\:tw-max-w-md {
    max-width: 28rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/myConversations/myconversations-tailwind.css"],"names":[],"mappings":"AACA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wCAAc;EAAd,0CAAc;EAAd,mCAAc;EAAd,8BAAc;EAAd,sCAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wCAAc;EAAd,0CAAc;EAAd,mCAAc;EAAd,8BAAc;EAAd,sCAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gBAAc,EAAd,MAAc;EAAd,cAAc;KAAd,WAAc,EAAd,MAAc;EAAd,8LAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,0BAAc;EAAd,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AAEd;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,QAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,yLAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,qLAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,2BAAmB;EAAnB,mDAAmB;EAAnB,gCAAmB;EAAnB,wDAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,2BAAmB;EAAnB,mDAAmB;EAAnB,gCAAmB;EAAnB,wDAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4BAAmB;EAAnB,oDAAmB;EAAnB,iCAAmB;EAAnB,yDAAmB;EAAnB,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+BAAmB;EAAnB,uDAAmB;EAAnB,mCAAmB;EAAnB,2DAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gCAAmB;EAAnB,wDAAmB;EAAnB,oCAAmB;EAAnB,4DAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gCAAmB;EAAnB,wDAAmB;EAAnB,oCAAmB;EAAnB,4DAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,2CAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,2CAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;KAAnB;AAAmB;AAAnB;EAAA,oBAAmB;KAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB,6DAAmB;EAAnB,uFAAmB;EAAnB;AAAmB;AAAnB;EAAA,mFAAmB;EAAnB,mGAAmB;EAAnB,wHAAmB;EAAnB;AAAmB;AAAnB;EAAA,iFAAmB;EAAnB,iGAAmB;EAAnB,sHAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB,iFAAmB;EAAnB;AAAmB;AAAnB;EAAA,oFAAmB;EAAnB,oGAAmB;EAAnB,yHAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB,kFAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB,kFAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;;;2CAG2C;;AAR3C;EAAA,oBASA;EATA,6BASA;EATA;AASA;;AATA;EAAA,oBASA;EATA,6BASA;EATA;AASA;;AATA;EAAA;AASA;;AATA;EAAA,iBASA;EATA,iBASA;EATA,mKASA;EATA;AASA;;AATA;EAAA,sBASA;EATA,oCASA;EATA;AASA;;AATA;EAAA,sBASA;EATA,oCASA;EATA;AASA;;AATA;EAAA,sBASA;EATA,mCASA;EATA;AASA;;AATA;EAAA,sBASA;EATA,mCASA;EATA;AASA;;AATA;EAAA,sBASA;EATA,oCASA;EATA;AASA;;AATA;EAAA,sBASA;EATA,oCASA;EATA;AASA;;AATA;EAAA,sBASA;EATA,oCASA;EATA;AASA;;AATA;EAAA,sBASA;EATA,oCASA;EATA;AASA;;AATA;EAAA,sBASA;EATA,oCASA;EATA;AASA;;AATA;EAAA,sBASA;EATA,mCASA;EATA;AASA;;AATA;EAAA,kBASA;EATA,wCASA;EATA;AASA;;AATA;EAAA,kBASA;EATA,wCASA;EATA;AASA;;AATA;EAAA,kBASA;EATA,wCASA;EATA;AASA;;AATA;EAAA,kBASA;EATA,wCASA;EATA;AASA;;AATA;EAAA,kBASA;EATA,uCASA;EATA;AASA;;AATA;EAAA,kBASA;EATA,wCASA;EATA;AASA;;AATA;EAAA,kBASA;EATA,wCASA;EATA;AASA;;AATA;EAAA,kBASA;EATA,wCASA;EATA;AASA;;AATA;EAAA,kBASA;EATA,wCASA;EATA;AASA;;AATA;EAAA,kBASA;EATA,wCASA;EATA;AASA;;AATA;EAAA,kBASA;EATA,sCASA;EATA;AASA;;AATA;EAAA,kBASA;EATA,wCASA;EATA;AASA;;AATA;EAAA,kBASA;EATA,wCASA;EATA;AASA;;AATA;EAAA,kBASA;EATA,wCASA;EATA;AASA;;AATA;EAAA,kBASA;EATA,wCASA;EATA;AASA;;AATA;EAAA,kBASA;EATA,wCASA;EATA;AASA;;AATA;EAAA;AASA;;AATA;EAAA,kBASA;EATA,wCASA;EATA;AASA;;AATA;EAAA,kBASA;EATA,wCASA;EATA;AASA;;AATA;EAAA;AASA;;AATA;EAAA;AASA;;AATA;EAAA;AASA;;AATA;EAAA,oBASA;EATA,2BASA;EATA;AASA;;AATA;EAAA,oBASA;EATA,2BASA;EATA;AASA;;AATA;EAAA,oBASA;EATA,2BASA;EATA;AASA;;AATA;EAAA,oBASA;EATA,2BASA;EATA;AASA;;AATA;EAAA,oBASA;EATA,4BASA;EATA;AASA;;AATA;EAAA,oBASA;EATA,4BASA;EATA;AASA;;AATA;EAAA,oBASA;EATA,0BASA;EATA;AASA;;AATA;EAAA,oBASA;EATA,0BASA;EATA;AASA;;AATA;EAAA,oBASA;EATA,0BASA;EATA;AASA;;AATA;EAAA,oBASA;EATA,2BASA;EATA;AASA;;AATA;EAAA,oBASA;EATA,2BASA;EATA;AASA;;AATA;EAAA,oBASA;EATA,2BASA;EATA;AASA;;AATA;EAAA,oBASA;EATA,2BASA;EATA;AASA;;AATA;EAAA,oBASA;EATA,6BASA;EATA;AASA;;AATA;EAAA,oBASA;EATA,2BASA;EATA;AASA;;AATA;EAAA;AASA;;AATA;EAAA;AASA;;AATA;EAAA;AASA;;AATA;EAAA,iFASA;EATA,iGASA;EATA,sHASA;EATA;AASA;;AATA;EAAA,sBASA;EATA,mCASA;EATA;AASA;;AATA;EAAA,sBASA;EATA,mCASA;EATA;AASA;;AATA;EAAA,sBASA;EATA,kCASA;EATA;AASA;;AATA;EAAA;AASA;;AATA;EAAA,kBASA;EATA,wCASA;EATA;AASA;;AATA;EAAA,8BASA;EATA;AASA;;AATA;EAAA,2GASA;EATA,yGASA;EATA,kFASA;EATA;AASA;;AATA;EAAA,2GASA;EATA,yGASA;EATA,kFASA;EATA;AASA;;AATA;EAAA,oBASA;EATA;AASA;;AATA;EAAA,oBASA;EATA;AASA;;AATA;EAAA,oBASA;EATA;AASA;;AATA;EAAA;AASA;;AATA;EAAA,kBASA;EATA,wCASA;EATA;AASA;;AATA;EAAA;AASA;;AATA;EAAA;AASA;;AATA;;EAAA;IAAA;EASA;;EATA;IAAA;EASA;AAAA;;AATA;;EAAA;IAAA;EASA;AAAA","sourcesContent":["@config \"./tailwind.config.js\";\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/* This file builds a namespaced Tailwind bundle scoped under the\n   .my-conversations selector (see `important` in the companion config).\n   Import this once in the app root so the scoped utilities are always\n   available when navigating client-side. */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
